export const USER_TYPES = {
  partner: 'PARTNER',
  subPartner: 'SUB_PARTNER',
  serviceProvider: 'SERVICE_PROVIDER',
};
